import { useEffect, useState } from 'react';
import useConfiguracion from '../../hooks/useConfiguracion';
import '../../styles/PoliticasUso.css';

// Guarda la versión de las políticas que el navegador ya aceptó. Si la entidad
// publica una versión nueva (`politicas_version`), se vuelve a pedir aceptación.
const CLAVE_VERSION = 'cn_politicas_version_aceptada';

// Permite abrir el texto en modo lectura desde cualquier parte (p. ej. el enlace
// del splash) sin acoplar los componentes: se dispara un evento de ventana.
export const EVENTO_ABRIR_POLITICAS = 'cn:abrir-politicas';
export const abrirPoliticas = () => {
  window.dispatchEvent(new Event(EVENTO_ABRIR_POLITICAS));
};

const leerVersionAceptada = () => {
  try { return localStorage.getItem(CLAVE_VERSION); } catch { return null; }
};
const guardarVersionAceptada = (version) => {
  try { localStorage.setItem(CLAVE_VERSION, version); } catch { /* sin storage */ }
};

/**
 * Políticas de uso y tratamiento de datos personales (Ley N.° 29733). Dos modos:
 *  - Obligatorio ("gate"): si `politicas_activas` está activo y esta versión no
 *    fue aceptada aún, cubre toda la app hasta que el ciudadano marque "He leído
 *    y acepto" (lo decide la entidad desde el panel).
 *  - Lectura: se abre con `abrirPoliticas()` (enlace del splash) para volver a
 *    consultar el texto en cualquier momento.
 */
const PoliticasUso = () => {
  const { configuracion } = useConfiguracion();
  const version = configuracion.politicas_version || '1.0';
  const activas = !!configuracion.politicas_activas;
  const [aceptada, setAceptada] = useState(() => leerVersionAceptada() === version);
  const [lectura, setLectura] = useState(false);
  const [marcado, setMarcado] = useState(false);

  useEffect(() => {
    const alAbrir = () => setLectura(true);
    window.addEventListener(EVENTO_ABRIR_POLITICAS, alAbrir);
    return () => window.removeEventListener(EVENTO_ABRIR_POLITICAS, alAbrir);
  }, []);

  const tieneTexto = !!(configuracion.politicas_contenido || configuracion.politicas_titulo);
  const esGate = activas && !aceptada && tieneTexto;

  if (!esGate && !(lectura && tieneTexto)) return null;

  const aceptar = () => {
    guardarVersionAceptada(version);
    setAceptada(true);
    setLectura(false);
  };

  return (
    <div className={`cn-politicas-overlay${esGate ? ' cn-politicas-overlay-gate' : ''}`} role="dialog" aria-modal="true">
      <div className="cn-politicas-caja">
        <h2 className="cn-politicas-titulo">
          {configuracion.politicas_titulo || 'Políticas de Uso'}
        </h2>

        <div className="cn-politicas-texto">{configuracion.politicas_contenido}</div>

        {esGate ? (
          <div className="cn-politicas-acciones">
            <label className="cn-politicas-check">
              <input
                type="checkbox"
                checked={marcado}
                onChange={(e) => setMarcado(e.target.checked)}
              />
              <span>He leído y acepto las Políticas de Uso y el tratamiento de mis datos personales.</span>
            </label>
            <button
              type="button"
              className="cn-politicas-btn"
              disabled={!marcado}
              onClick={aceptar}
            >
              Aceptar y continuar
            </button>
          </div>
        ) : (
          <div className="cn-politicas-acciones">
            <button type="button" className="cn-politicas-btn" onClick={() => setLectura(false)}>
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PoliticasUso;
